export default __webpack_public_path__ + "static/media/CryptoLogo.3a20d764.svg";